import { Injectable } from '@angular/core';
import { EnquiryTypeModel, QuoteTypeModel } from '@entity/logical-models';
import { IMyDate, IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { EnquiryModel, EnquiryStatus } from '@entity/enquiry-model';

@Injectable({
  providedIn: 'root'
})
export class LogicalService {
  dateFormat = 'dd/mm/yyyy';
  constructor() { }

  /** Format date to send to the server */
  getDateFormater(val: IMyDateModel | any) {
    if (!val) {
      return val;
    } else if (val.date) {
      return `${val.date.year}-${this.n(val.date.month)}-${this.n(
        val.date.day
      )}`;
    } else if (val.formatted) {
      return this.reverseString(val.formatted);
    }
    return val;
  }

  getDateFormaterddmmyy(val: IMyDateModel | any) {
    if (!val) {
      return val;
    } else if (val) {
      return (
        val
          .split('-')
          //  .reverse()
          .join('/')
      );
    }
    return val;
  }

  /** To give date to the datePicker */
  setDateFormater(val: string, format?: string) {
    let dat = '';
    if (format === 'IN') {
      dat = val;
    } else {
      dat = this.reverseString(val.split(' ')[0]);
    }
    return <IMyDateModel | any>{ formatted: dat };
  }

  private reverseString(val: string) {
    let dat = val;
    if (val && val.match(/\//)) {
      dat = val
        .split('/')
        .reverse()
        .join('/');
    } else if (val && val.match(/-/)) {
      dat = val
        .split('-')
        .reverse()
        .join('/');
    }
    return dat;
  }

  ddMMYYYY(str: string): string {
    return str
      .split('/')
      .join('-');
  }

  splitCamelCase(str: any): string {
    str = str.split(/(?=[A-Z])/g);
    return str
      .map(word => {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(' ');
  }

  copy(data: any): any {
    return JSON.parse(JSON.stringify(data));
  }

  scrollUP(): void {
    // document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }

  currentDateForDatePicker() {
    const date = this.currentDate();
    return date as IMyDate;
  }

  disableTillDate(
    options: IMyDpOptions,
    parentOption: IMyDpOptions,
    ev?: IMyDateModel
  ) {
    const data = <IMyDpOptions>this.copy(options);
    const parent = <IMyDpOptions>this.copy(parentOption);
    let date: IMyDate;
    if (ev.jsdate) {
      const myday = new Date(ev.jsdate);
      const finalDate = new Date(new Date(myday).setDate(myday.getDate() - 1));
      date = {
        day: finalDate.getDate(),
        month: finalDate.getMonth() + 1,
        year: finalDate.getFullYear()
      } as IMyDate;
    } else {
      date = parent.disableUntil;
    }
    data.disableUntil = date;
    return data;
  }

  highLightDates(options: IMyDpOptions, arr: any[]): IMyDpOptions {
    const data: IMyDpOptions = this.copy(options);
    let temp = [];
    if (arr[0]) {
      temp = arr.map(res => {
        const spl = res.split('-');
        const day = +spl[0];
        const month = +spl[1];
        const year = +spl[2];
        return { day, month, year };
      });
    }
    data.highlightDates = temp;
    return data;
  }

  arrayToggle(array: any[], data: any): any[] {
    const clonedArray = this.copy(array || []);
    const cond = clonedArray.indexOf(data);
    if (cond > -1) {
      clonedArray.splice(cond, 1);
    } else {
      clonedArray.push(data);
    }
    return clonedArray;
  }

  arrayReplace(array: any[], data: any, key: any): any[] {
    const clonedArray: any[] = this.copy(array);
    const cond = clonedArray.find(a => a[key] === data[key]);
    const dataIndex = clonedArray.indexOf(cond);
    if (dataIndex > -1) {
      clonedArray[dataIndex] = data;
    }
    return clonedArray;
  }

  currentDate() {
    const date = new Date();
    const month = date.getMonth() + 1;
    const day = date.getDate() - 1;
    const year = date.getFullYear();
    return { month, day, year };
  }

  n(n) {
    return ('00' + n).slice(-2);
  }

  formatDropdown(
    arr: any[],
    key: string,
    value: string,
    storeTo: Object,
    name: string
  ): object {
    const ar = this.copy(arr);
    const store = this.copy(storeTo);
    const data = ar.reduce((acc, curr) => {
      acc[curr[key]] = curr[value];
      return acc;
    }, {});
    store[name] = data;
    return store;
  }

  arrayFindDuplicate(array: any[], key: any) {
    const filterEmpty = array.filter(c => c[key]);
    const arrayKeys = filterEmpty.map(x => +x[key]);
    let duplicate = [];
    duplicate = arrayKeys.reduce((e, c) => {
      if (c && !e.includes(+c)) {
        e.push(c);
      }
      return e;
    }, []);
    console.log(arrayKeys, duplicate);
    return duplicate.join() !== arrayKeys.join();
  }

  objectToggle(object: Object, key: any, value?: any): Object | boolean {
    const obj = this.copy(object) as Object;
    if (!value) {
      return obj.hasOwnProperty(key);
    }
    if (obj.hasOwnProperty(key)) {
      delete obj[key];
    } else {
      obj[key] = value || '';
    }
    return obj;
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  handleEnquiryType(enq: EnquiryModel): EnquiryTypeModel {
    const id = enq.enquiry.EnquiryTypeId;
    const showPackagingTab = [202, 204].includes(id);
    const showTransportTab = [201, 204].includes(id);
    const collection = !!(
      enq.transport.Collection && enq.transport.Collection.Location
    );

    return new EnquiryTypeModel(
      showPackagingTab,
      showTransportTab,
      id === 202,
      id === 201,
      collection
    );
  }

  /** Know the status of the Quote 2104, 2115, 2105, 2108, 2109
   * @param Code 2104 is comes on transport quote
   */
  statusOfTheQuote(data) {
    const code = [
      EnquiryStatus.EligibleHauliersIdentification,
      EnquiryStatus.LLWRQuoteFinalisation,
      EnquiryStatus.QuoteRequestedFromHauliers,
      EnquiryStatus.QuoteReceivedFromHauliers,
      EnquiryStatus.QuoteAwardedToHaulier,
      EnquiryStatus.QuoteSubmissionInProgress
    ];
    let final: QuoteTypeModel;
    if (code.includes(data.Status)) {
      const showSaveBtn = data.Status === EnquiryStatus.QuoteAwardedToHaulier;
      const showAwardBtn =
        data.Status === EnquiryStatus.QuoteReceivedFromHauliers;
      const showAssignBtn =
        data.Status === EnquiryStatus.LLWRQuoteFinalisation ||
        data.Status === EnquiryStatus.EligibleHauliersIdentification;
      const isHauilerAssigned =
        data.Status === EnquiryStatus.QuoteRequestedFromHauliers ||
        showSaveBtn ||
        showAwardBtn ||
        data.Status === EnquiryStatus.QuoteSubmissionInProgress;
      const isHaulierAwarded =
        data.Status === EnquiryStatus.QuoteAwardedToHaulier;

      final = new QuoteTypeModel(
        isHauilerAssigned,
        isHaulierAwarded,
        showAssignBtn,
        showAwardBtn,
        showSaveBtn
      );
    }
    else if (data.Status == EnquiryStatus.TransportCostFrozen) {
      final = new QuoteTypeModel(true, true, false, false, false);
    }
    else {
      final = new QuoteTypeModel(true, true, false, false, true);
    }
    return final;
  }

  //Get Print Image Global Url..
  // PrintImageUrl() {
  //   return "https://llwr.cyb.co.uk/assets/images/LLWR2.png"
  // }

  // Phone Number Validation
  phoneNoValid(event) {
    let tPhoneNo = event.target.value.toString().replace(/[\s]/g, '').trim();
    let phoneNo = tPhoneNo.slice(0, 5) + " " + tPhoneNo.slice(5);
    if (phoneNo.replace(/[\s]/g, '') === event.target.value.toString().replace(/[\s]/g, '')) {
      phoneNo = phoneNo.trim();
    }
    return phoneNo ;
  }
}
